import * as home from '../types/home'
import { getProductList } from '../../api/home'

import { cards } from 'constants/cards'
import { cardOrder } from 'constants/card-order'

export const openProductModal = (group) => ({
    type: home.OPEN_PRODUCT_MODAL,
    payload: { group }
})

export const closeProductModal = () => ({
    type: home.CLOSE_PRODUCT_MODAL
})

export const openProductAliRefModal = () => ({
    type: home.OPEN_PRODUCT_ALI_REF_MODAL
})

export const closeProductAliRefModal = () => ({
    type: home.CLOSE_PRODUCT_ALI_REF_MODAL
})

export const openProductOthersModal = () => ({
    type: home.OPEN_PRODUCT_OTHERS_MODAL
})

export const closeProductOthersModal = () => ({
    type: home.CLOSE_PRODUCT_OTHERS_MODAL
})

export const openPatModal = () => ({
    type: home.OPEN_PAT_MODAL
})

export const closePatModal = () => ({
    type: home.CLOSE_PAT_MODAL
})

export const fetchProductsPending = () => ({
    type: home.FETCH_PRODUCTS_PENDING
})

export const fetchProductsSuccess = (data) => ({
    type: home.FETCH_PRODUCTS_SUCCESS,
    payload: { data }
})

export const fetchProductsFailed = (error) => ({
    type: home.FETCH_PRODUCTS_FAILED,
    payload: { error }
})

export const setCarouselProducts = (products) => ({
    type: home.SET_CAROUSEL_PRODUCTS,
    payload: { products }
})

export const flipProduct = (code) => ({
    type: home.FLIP_PRODUCT,
    payload: { code }
})

export const getProducts = (bank) => (dispatch) => {
    dispatch(fetchProductsPending())

    const bankName = bank === 'AL' ? '' : bank
    return getProductList(bankName)
        .then((response) => {
            const data = response.data
                .map((product) => ({
                    ...product,
                    code: product.productCode.toString(),
                    description: product.productName,
                    name: product.productName,
                    flipped: false,
                    vendible: true
                }))
                .toSorted((p1, p2) => cardOrder[p1.code] - cardOrder[p2.code])

            const cardFilteredPerBank = cards
                .filter((c) => c.showTo.includes(bank))
                .map((c) => ({ ...c, flipped: false }))

            dispatch(fetchProductsSuccess([...data, ...cardFilteredPerBank]))
        })
        .catch(() => {
            dispatch(fetchProductsFailed('Ops! Algo de errado aconteceu :('))

            return { status: 'error' }
        })
}

export const reset = () => ({
    type: home.RESET
})
